document.addEventListener('DOMContentLoaded', function () {
  var searchIconTrigger = document.getElementById('search-icon-trigger');
  var searchDropdownContent = document.getElementById('search-dropdown-content');

  console.log('Event listener attached.');

  if (searchIconTrigger && searchDropdownContent) {
    searchIconTrigger.addEventListener('click', function () {
      // Use getComputedStyle to get the actual visibility state
      var computedStyle = window.getComputedStyle(searchDropdownContent);
      var isDropdownVisible = computedStyle.display === 'block';

      if (isDropdownVisible) {
        searchDropdownContent.style.display = 'none';
      } else {
        searchDropdownContent.style.display = 'block';
      }

      // Console log
      console.log('Search icon clicked. Dropdown visibility:', searchDropdownContent.style.display);
    });
  }
});